/* mm-pdp-buy v1.3 (2026-10-12: natural mode shows natural From prices in the carat dropdown and the phone bar opens the natural diamond drawer; v1.2 2026-09-30: Add to bag total includes Priority crafting with the new Easify po-* widget; v1.1 2026-09-28: Shop Pay line font; v1.0 2026-09-27) — Modern Mangal PDP buying column (Phase 2).
   Pairs with snippets/mm-pdp-buy.liquid + assets/mm-pdp-buy.css.
   The theme's hidden <variant-selects> stays the source of truth: every pick sets the native <select>
   and dispatches 'change' so global.js runs its usual variant chain (media, URL, price, 'variant:change'). */
(() => {
  const opts = document.querySelector('[data-mm-opts]');
  const dataEl = document.querySelector('[data-mm-buy-json]');
  if (!dataEl || document.documentElement.dataset.mmBuy) return;
  document.documentElement.dataset.mmBuy = '1';

  const cfg = JSON.parse(dataEl.textContent);
  const main = document.querySelector('[id^="MainProduct-"]') || document;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const isPhone = () => window.matchMedia('(max-width: 989px)').matches;
  const natural = () => !!window.MM_NATURAL_ON;
  // v1.3: natural From price per variant, published by snippets/mm-natural-diamond.liquid v2.0
  const natFrom = (v) => (v && window.MM_NAT_FROM && window.MM_NAT_FROM[v.id]) || '';

  // ---------- helpers ----------
  const picker = () => main.querySelector('variant-selects, variant-radios');
  const selects = () => { const p = picker(); return p ? [...p.querySelectorAll('select')] : []; };
  const current = () => selects().map((s) => s.value);
  const find = (o) => cfg.variants.find((v) => v.o.every((x, i) => x === o[i]));
  const money = (cents) => {
    try {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: cfg.currency || 'USD', minimumFractionDigits: cents % 100 ? 2 : 0, maximumFractionDigits: 2 }).format(cents / 100);
    } catch (e) { return '$' + (cents / 100).toLocaleString('en-US'); }
  };
  // Easify add-on total in cents. New widget (po-*, Sep 2026): add up the prices of the ticked options,
  // else read the "additional charge of $X" summary. Old widget (tpo_*): its hidden total input.
  const easifyExtra = () => {
    const num = (t) => { const n = parseFloat(String(t || '').replace(/,/g, '').replace(/[^0-9.]/g, '')); return isNaN(n) ? 0 : Math.round(n * 100); };
    const old = main.querySelector('.tpo_total-additional-price-input');
    if (old) return num(old.value);
    let sum = 0;
    main.querySelectorAll('.po-optionItemLabel-price').forEach((p) => {
      const opt = p.closest('.po-checkboxOption-option, .po-radioOption-option, [class*="Option-option"]');
      const inp = opt && opt.querySelector('input[type=checkbox], input[type=radio]');
      if (inp && inp.checked && !opt.closest('.mm-easify-hidden')) sum += num(p.textContent);
    });
    if (sum) return sum;
    const sp = main.querySelector('.po-priceSummary-price');
    return sp && sp.offsetParent ? num(sp.textContent) : 0;
  };
  const atcBtn = () => main.querySelector('product-form [name="add"]');

  // ---------- option controls ----------
  function choose(i, val) {
    const s = selects()[i];
    if (!s) return;
    if (s.value !== val) {
      s.value = val;
      s.dispatchEvent(new Event('change', { bubbles: true }));
    }
    sync();
  }

  function sync() {
    if (!opts) return;
    const o = current();
    const v = find(o);
    opts.querySelectorAll('[data-mm-opt]').forEach((fs) => {
      const i = Number(fs.dataset.mmOpt);
      const kind = fs.dataset.kind;
      const priceFor = (val) => { const t = o.slice(); t[i] = val; return find(t); };
      fs.querySelectorAll('.mm-chips [data-value]').forEach((b) => {
        const val = b.dataset.value;
        b.setAttribute('aria-pressed', String(val === o[i]));
        const alt = priceFor(val);
        b.disabled = !alt;
        b.classList.toggle('is-soldout', !!alt && !alt.a);
      });
      const out = fs.querySelector('[data-mm-value]');
      if (out && kind !== 'carat') out.textContent = o[i] || '';
      if (kind === 'carat') {
        const cur = fs.querySelector('[data-mm-csel-cur]');
        if (cur) cur.innerHTML = '<b>' + o[i] + ' ct</b><i>' + (v ? (natural() ? natFrom(v) : money(v.p)) : '') + '</i>';
        fs.querySelectorAll('[data-mm-csel-list] [data-value]').forEach((li) => {
          const alt = priceFor(li.dataset.value);
          li.setAttribute('aria-selected', String(li.dataset.value === o[i]));
          li.setAttribute('aria-disabled', String(!alt));
          const p = li.querySelector('[data-mm-price]');
          if (p) p.textContent = alt ? (natural() ? natFrom(alt) : money(alt.p)) : 'Unavailable';
        });
      }
    });
    updateAtc();
  }

  if (opts) {
    opts.addEventListener('click', (e) => {
      const b = e.target.closest('.mm-chips [data-value]');
      if (b && !b.disabled) choose(Number(b.closest('[data-mm-opt]').dataset.mmOpt), b.dataset.value);
    });

    // length guide (tap to open)
    const lg = opts.querySelector('[data-mm-lenguide]');
    const pop = opts.querySelector('#mm-lenpop');
    if (lg && pop) lg.addEventListener('click', (e) => {
      e.preventDefault();
      const open = lg.getAttribute('aria-expanded') !== 'true';
      lg.setAttribute('aria-expanded', String(open));
      pop.hidden = !open;
    });

    // carat dropdown
    const csel = opts.querySelector('[data-mm-csel]');
    if (csel) {
      const btn = csel.querySelector('[data-mm-csel-btn]');
      const list = csel.querySelector('[data-mm-csel-list]');
      const idx = Number(csel.closest('[data-mm-opt]').dataset.mmOpt);
      const setOpen = (open) => {
        list.hidden = !open;
        btn.setAttribute('aria-expanded', String(open));
        if (open) { const c = list.querySelector('[aria-selected="true"]') || list.firstElementChild; c && c.focus(); }
      };
      btn.addEventListener('click', () => setOpen(list.hidden));
      list.addEventListener('click', (e) => {
        const li = e.target.closest('[data-value]');
        if (!li || li.getAttribute('aria-disabled') === 'true') return;
        setOpen(false);
        choose(idx, li.dataset.value);
        btn.focus();
      });
      list.addEventListener('keydown', (e) => {
        const items = [...list.children];
        const i = items.indexOf(document.activeElement);
        if (e.key === 'ArrowDown') { e.preventDefault(); items[Math.min(items.length - 1, i + 1)].focus(); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); items[Math.max(0, i - 1)].focus(); }
        else if (e.key === 'Home') { e.preventDefault(); items[0].focus(); }
        else if (e.key === 'End') { e.preventDefault(); items[items.length - 1].focus(); }
        else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); document.activeElement.click(); }
        else if (e.key === 'Escape' || e.key === 'Tab') { setOpen(false); if (e.key === 'Escape') btn.focus(); }
      });
      document.addEventListener('click', (e) => { if (!list.hidden && !e.target.closest('[data-mm-csel]')) setOpen(false); });

      // "See it on the model" (created by mm-pdp-gallery.js inside <variant-selects>) moves under the carat dropdown
      let tries = 0;
      const moveSee = () => {
        const b = main.querySelector('.mm-seemodel');
        if (b && !csel.parentNode.contains(b)) csel.insertAdjacentElement('afterend', b);
        else if (!b && tries++ < 25) setTimeout(moveSee, 200);
      };
      moveSee();
    }
  }

  // keep controls in step with any other way the variant changes (URL, stock list, natural panel)
  document.addEventListener('variant:change', () => setTimeout(sync, 0));
  document.addEventListener('mm:natural-prices', () => sync());
  document.addEventListener('mm:natural-mode', () => setTimeout(sync, 0));
  document.addEventListener('change', (e) => { if (e.target.closest && e.target.closest('variant-selects, variant-radios')) setTimeout(sync, 0); });

  // ---------- Add to bag label ("Add to bag · $X", includes Easify add-ons) ----------
  let atcObs = null;
  let atcObsEl = null;
  function updateAtc() {
    const b = atcBtn();
    if (!b) return;
    const span = b.querySelector('span');
    const v = find(current());
    if (span && v && v.a && !b.disabled) {
      const want = 'Add to bag · ' + money(v.p + easifyExtra());
      if (span.textContent.trim() !== want) span.textContent = want;
    }
    const sp = document.querySelector('[data-mm-sbar-price]');
    if (sp && v) sp.textContent = natural() ? (window.MM_NAT_PRICE || '') : money(v.p + easifyExtra());
    const sn = document.querySelector('[data-mm-sbar-name]');
    const ci = opts ? opts.querySelector('[data-kind="carat"]') : null;
    if (sn) sn.textContent = cfg.short + (ci && v ? ' · ' + v.o[Number(ci.dataset.mmOpt)] + ' ct' : '');
    if (b !== atcObsEl) {
      if (atcObs) atcObs.disconnect();
      atcObsEl = b;
      atcObs = new MutationObserver(() => requestAnimationFrame(updateAtc));
      atcObs.observe(b, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });
    }
  }
  ['change', 'click', 'input'].forEach((t) => main.addEventListener(t, (e) => {
    if (e.target.closest && e.target.closest('.tpo_option-set-wrapper, .po-productPageOptions-root, product-form')) setTimeout(updateAtc, 120);
  }));

  // ---------- slim Made to Order line (reads mm-variant-discovery's badge + ship-by date) ----------
  const badge = document.getElementById('mm-delivery-badge');
  const ship = document.getElementById('mm-ship-date');
  if (badge && ship) {
    const line = document.createElement('div');
    line.className = 'mm-mto';
    line.setAttribute('role', 'status');
    badge.parentNode.insertBefore(line, badge);
    document.documentElement.classList.add('mm-mto-on');
    const render = () => {
      const lbl = badge.querySelector('.mm-badge__label');
      const label = lbl ? lbl.textContent.trim() : 'Made to Order';
      const rts = !!badge.querySelector('.mm-badge--rts');
      const exp = /expedited/i.test(ship.className + ' ' + ship.textContent);
      let tf = badge.textContent.replace(label, '').replace('·', '').trim()
        .replace(/^(ships in|crafted in)\s*/i, '').replace(/^(approximately|approx\.?|~)\s*/i, 'about ');
      if (natural() && !rts) tf = 'about 3 weeks, including sourcing your diamond';
      const m = ship.textContent.match(/([A-Z][a-z]+ \d{1,2}, \d{4})/);
      const title = rts ? label : exp ? 'Expedited' : label;
      const html = '<span class="mm-mto__t">' + title + '</span><span class="mm-mto__d">' +
        (m ? 'Ships by <b>' + m[1] + '</b>' + (tf ? ' · ' + tf : '') : tf) + '</span>';
      if (line.innerHTML !== html) line.innerHTML = html;
      line.classList.toggle('mm-mto--rts', rts);
    };
    const mo = new MutationObserver(render);
    [badge, ship].forEach((n) => mo.observe(n, { childList: true, subtree: true, characterData: true, attributes: true }));
    document.addEventListener('mm:natural-mode', () => setTimeout(render, 50));
    render();
  }

  // ---------- Lab | Natural toggle label (panel itself is rebuilt in Phase 3) ----------
  const natLabel = document.querySelector('.mm-nat__toggle-label');
  if (natLabel) natLabel.textContent = 'Diamond';

  // ---------- "Full details" ----------
  document.addEventListener('click', (e) => {
    const a = e.target.closest('[data-mm-fulldetails]');
    if (!a) return;
    const t = document.getElementById('mm-details') || main.querySelector('.product__description') || main.querySelector('.product__accordion, details');
    if (!t) return;
    e.preventDefault();
    t.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
  });

  // ---------- rating link: go to the reviews widget if it's on the page ----------
  const rl = document.querySelector('[data-mm-rating]');
  if (rl) rl.addEventListener('click', (e) => {
    const t = document.getElementById('judgeme_product_reviews') || document.querySelector('.jdgm-review-widget, .jdgm-widget.jdgm-review-widget');
    if (!t) return;
    e.preventDefault();
    t.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
  });

  // ---------- sticky Add to bag bar (phones) ----------
  const bar = document.querySelector('[data-mm-sbar]');
  if (bar) {
    document.body.appendChild(bar); // escape the sticky info column
    const sbBtn = bar.querySelector('[data-mm-sbar-btn]');
    let past = false;
    const show = () => {
      const on = isPhone() && past;
      bar.classList.toggle('on', on);
      bar.setAttribute('aria-hidden', String(!on));
      sbBtn.tabIndex = on ? 0 : -1;
      document.documentElement.classList.toggle('mm-sbar-on', on);
      sbBtn.textContent = natural() ? (window.MMNatural && window.MMNatural.complete() ? 'Add to bag' : 'Choose diamond') : 'Add to bag';
    };
    const target = () => {
      if (natural()) return document.getElementById('mm-natural');
      const b = atcBtn();
      return b && b.offsetParent ? b : (b && b.closest('product-form')) || null;
    };
    const check = () => {
      const t = target();
      if (!t) { past = false; return show(); }
      past = t.getBoundingClientRect().bottom < 0;
      show();
    };
    let tick = false;
    window.addEventListener('scroll', () => { if (!tick) { tick = true; requestAnimationFrame(() => { tick = false; check(); }); } }, { passive: true });
    window.addEventListener('resize', check);
    document.addEventListener('mm:natural-mode', check);
    document.addEventListener('mm:natural-prices', check);
    sbBtn.addEventListener('click', () => {
      if (natural() && window.MMNatural) { if (window.MMNatural.complete()) window.MMNatural.addToBag(); else window.MMNatural.open(); return; }
      const t = target();
      if (!t) return;
      t.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
      if (!natural()) {
        const b = atcBtn();
        if (b && !b.disabled) setTimeout(() => b.click(), reduceMotion ? 0 : 350);
      }
    });
    check();
  }

  // ---------- BriteCo insurance line: re-attach if it lost the race with Easify ----------
  // BriteCo attaches next to form[action*="/cart/add"] [type=submit]; Easify turns that button into
  // type="button", so when Easify loads first BriteCo never shows. Briefly restore the type and re-run it.
  let bcTries = 0;
  const ensureBriteco = () => {
    const B = window.BRITE_CO;
    if (document.querySelector('.briteco-insure-link') || !B || typeof B.appInit !== 'function' || bcTries >= 4) return;
    const b = atcBtn();
    if (!b) return;
    bcTries++;
    const t = b.getAttribute('type');
    if (t === 'submit') { try { B.appInit(); } catch (e) {} return; }
    const restore = () => {
      if (t) b.setAttribute('type', t);
      ['pointerdown', 'keydown', 'touchstart', 'click'].forEach((ev) => b.removeEventListener(ev, restore, true));
    };
    // any interaction restores Easify's type first, so a click can never double-submit
    ['pointerdown', 'keydown', 'touchstart', 'click'].forEach((ev) => b.addEventListener(ev, restore, true));
    try {
      b.setAttribute('type', 'submit');
      B.appInit();
    } catch (e) {}
    setTimeout(restore, 1500);
  };
  setTimeout(ensureBriteco, 2500);
  setTimeout(ensureBriteco, 7000);
  document.addEventListener('variant:change', () => setTimeout(ensureBriteco, 1500));

  // ---------- Shop Pay installments line: use the site's type (the widget ships its own GT Standard font) ----------
  const SP_CSS = '*{font-family:inherit!important;letter-spacing:0!important}.font-bold,b,strong{font-weight:500!important}';
  const spPatch = (el) => {
    const sr = el.shadowRoot;
    if (!sr) return;
    const add = () => {
      if (sr.querySelector('style[data-mm]')) return;
      const st = document.createElement('style');
      st.setAttribute('data-mm', '');
      st.textContent = SP_CSS;
      sr.appendChild(st);
    };
    add();
    if (!el.__mmObs) { el.__mmObs = new MutationObserver(add); el.__mmObs.observe(sr, { childList: true }); }
  };
  const spFix = () => main.querySelectorAll('shopify-payment-terms').forEach(spPatch);
  const spWrap = main.querySelector('.installment-wrapper');
  if (spWrap) new MutationObserver(spFix).observe(spWrap, { childList: true, subtree: true });
  spFix();
  setTimeout(spFix, 1500);
  setTimeout(spFix, 4000);
  document.addEventListener('variant:change', () => setTimeout(spFix, 600));

  sync();
  setTimeout(sync, 1200); // after Easify has swapped in its button
  setInterval(updateAtc, 1500); // belt and braces: theme / Easify can rewrite the button label
})();
